import { Box, Typography } from '@mui/material'

import { SuccessCheckIcon } from 'components/common'

interface DeliverySuccessProps {
  deliveryTime?: string
  completionType?: 'collection' | 'delivery'
}

const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2,
  textAlign: 'center',
}

const iconContainerStyles = {
  width: 60,
  height: 60,
  borderRadius: '50%',
  backgroundColor: '#D3F5C9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 2,
}

const titleStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: '#2E7D32',
  mb: 1,
}

const subtitleStyles = {
  fontSize: '16px',
  fontWeight: 500,
  color: '#383838',
  mb: 2,
  letterSpacing: '0.15px',
}

export const DeliverySuccess = ({ deliveryTime, completionType = 'delivery' }: DeliverySuccessProps) => {
  const isCollection = completionType === 'collection'
  return (
    <Box sx={containerStyles}>
      <Box sx={iconContainerStyles}>
        <SuccessCheckIcon sx={{ fontSize: 44, color: '#2E7D32' }} />
      </Box>

      <Typography sx={titleStyles}>
        {isCollection ? 'Collection Complete' : 'Package Delivered'}
      </Typography>

      <Typography sx={subtitleStyles}>
        {isCollection
          ? `Package successfully collected${deliveryTime ? ` at ${deliveryTime}` : ''}`
          : `Package successfully delivered${deliveryTime ? ` at ${deliveryTime}` : ''}`}
      </Typography>
    </Box>
  )
}
